import React from 'react';

import styles from './LargeDestinationCard.module.css';

const LargeDestinationCard = ({ location, price, image }) => {
    return(
        <div className={styles.LargeDestinationCardWrapper}>
           <img className={styles.LargeDestinationCardImage} alt={location} src={image}/>
           <h4 className={styles.LargeDestinationCardLocation}>{location}</h4>
           <p className={styles.LargeDestinationCardPrice}>{`Flights from $${price}`}</p>
        </div>
    )
}

export default LargeDestinationCard;


// WEBPACK FOOTER //
// ./src/components/LargeDestinationCard/LargeDestinationCard.jsx